/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Share_Title_PrefixInputs */

const bn_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কান্ট্রি ড্যাশ ডেইলি`)
};

const de_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash Daily`)
};

const el_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash Daily`)
};

const en_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash Daily`)
};

const es_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash diario`)
};

const fr_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash Quotidien`)
};

const hi_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कंट्री डैश डेली`)
};

const hu_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash Daily`)
};

const id_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dash Negara Setiap Hari`)
};

const it_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paese Dash quotidiano`)
};

const ja_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カントリーダッシュデイリー`)
};

const ko_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`컨트리 대시 데일리`)
};

const nl_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash dagelijks`)
};

const pl_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash Daily`)
};

const pt_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash diariamente`)
};

const ru_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash Daily`)
};

const sv_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash dagligen`)
};

const tr_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ülke Dash Günlük`)
};

const uk_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash Daily`)
};

const vi_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash hàng ngày`)
};

const zh_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`乡村短跑日报`)
};

const zh_hant_daily_share_title_prefix = /** @type {(inputs: Daily_Share_Title_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`鄉村短跑日報`)
};

/**
* | output |
* | --- |
* | "Country Dash Daily" |
*
* @param {Daily_Share_Title_PrefixInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const daily_share_title_prefix = /** @type {((inputs?: Daily_Share_Title_PrefixInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Share_Title_PrefixInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_daily_share_title_prefix(inputs)
	if (locale === "de") return de_daily_share_title_prefix(inputs)
	if (locale === "el") return el_daily_share_title_prefix(inputs)
	if (locale === "en") return en_daily_share_title_prefix(inputs)
	if (locale === "es") return es_daily_share_title_prefix(inputs)
	if (locale === "fr") return fr_daily_share_title_prefix(inputs)
	if (locale === "hi") return hi_daily_share_title_prefix(inputs)
	if (locale === "hu") return hu_daily_share_title_prefix(inputs)
	if (locale === "id") return id_daily_share_title_prefix(inputs)
	if (locale === "it") return it_daily_share_title_prefix(inputs)
	if (locale === "ja") return ja_daily_share_title_prefix(inputs)
	if (locale === "ko") return ko_daily_share_title_prefix(inputs)
	if (locale === "nl") return nl_daily_share_title_prefix(inputs)
	if (locale === "pl") return pl_daily_share_title_prefix(inputs)
	if (locale === "pt") return pt_daily_share_title_prefix(inputs)
	if (locale === "ru") return ru_daily_share_title_prefix(inputs)
	if (locale === "sv") return sv_daily_share_title_prefix(inputs)
	if (locale === "tr") return tr_daily_share_title_prefix(inputs)
	if (locale === "uk") return uk_daily_share_title_prefix(inputs)
	if (locale === "vi") return vi_daily_share_title_prefix(inputs)
	if (locale === "zh") return zh_daily_share_title_prefix(inputs)
	return zh_hant_daily_share_title_prefix(inputs)
});